export default "__VITE_ASSET__B6g6Nmt9__"